import { Backdrop, Card, CardContent, CardHeader, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const BackdropTypes = {
  None: "none",
  Transparent: "transparent",
  Solid: "solid",
};

const ScopedPopup = ({ onClose, open, persistent, backdrop = "none", title, description, children }) => {
  const handleClose = () => {
    onClose();
  };

  const popupContent = (
    <Card sx={{ minWidth: 275, zIndex: 2 }} onClick={(event) => event.stopPropagation()}>
      <CardHeader
        action={
          !persistent ? (
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          ) : null
        }
        title={title}
        subheader={description}
      />
      <CardContent>{children}</CardContent>
    </Card>
  );

  if (backdrop === BackdropTypes.None) {
    return (
      open && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}>
          {popupContent}
        </div>
      )
    );
  } else if (backdrop === BackdropTypes.Transparent) {
    return (
      <Backdrop
        sx={{ color: "#fff", position: "absolute", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        //   onClick={!persistent ? handleClose : null}
      >
        {popupContent}
      </Backdrop>
    );
  } else if (backdrop === BackdropTypes.Solid) {
    return (
      <div
        style={{
          position: "absolute",
          background: "rgba(255,255,255,1)",
          top: "0",
          bottom: "0",
          left: "0",
          right: "0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        {popupContent}
      </div>
    );
  }
};

export default ScopedPopup;
